import Axios from 'axios';

import { hopplerApi } from '../../constants';
import { KumitaMultimedia, UploadablePhoto, ListResponse } from '../../types';

export class PhotoUploadService {
  async upload(photos: UploadablePhoto[]) {
    const formData = new FormData();
    photos.forEach(member => {
      formData.append('file[]', member.file, member.file['name']);
    });

    const response = await Axios.post<ListResponse<KumitaMultimedia>>(
      `${hopplerApi.host}/kumita/listing/multimedia`,
      formData,
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );

    const uploadedPhotos: KumitaMultimedia[] = [];
    for (let i = 0; i < response.data.results.length; i++) {
      uploadedPhotos.push({
        media: response.data.results[i].media,
        id: response.data.results[i].id,
        isPrimary: 0,
        url: photos[i].url
      });
    }

    return uploadedPhotos;
  }
}

export const photoUploadService = new PhotoUploadService();
